import LoadingObject, { LoadingObjectType } from '@/components/view/atoms/loading/LoadingObject'
import Table from '@/components/view/atoms/table/Table'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Area from '@/components/view/layouts/area/Area'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'

const Row = () => (
  <TableRow>
    <TableRowItem checkbox width={40}>
      <LoadingObject type={LoadingObjectType.THUMBNAIL_MICRO} />
    </TableRowItem>
    <TableRowItem sticky={40} type='low' thumbnail>
      <LoadingObject type={LoadingObjectType.THUMBNAIL_SMALL} />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
  </TableRow>
)

interface Props {
  small?: boolean
}

const PageListLoading = ({ small = false }: Props) => {
  return (
    <div className='w-full overflow-hidden'>
      <Area>
        <div className='flex items-center justify-between px-3 py-2'>
          <SortButtonList>
            <LoadingObject type={LoadingObjectType.INPUT} />
            {!small && (
              <>
                <LoadingObject type={LoadingObjectType.INPUT} />
                <LoadingObject type={LoadingObjectType.INPUT} />
              </>
            )}
          </SortButtonList>
          <LoadingObject type={LoadingObjectType.BUTTON_LONG} />
        </div>
        <LoadingObject type={LoadingObjectType.LINE} />
        <Table>
          <tbody>
            {[...Array(16)].map((_, index) => (
              <Row key={index} />
            ))}
          </tbody>
        </Table>
      </Area>
    </div>
  )
}

export default PageListLoading
